import * as $ from "jquery";
import onThrottled from "../utils/event";
import "waypoints/lib/jquery.waypoints.js";

export default class StickyElement {
  stuckClass = "stuck";
  stuckBodyClass = "stuck-body";
  $domRoot: JQuery<HTMLElement>;
  params: any;
  disableSticky: boolean;
  waypoint: any;
  $wrapper: any;

  constructor(domRoot: HTMLElement, params: any) {
    this.$domRoot = $(domRoot);
    this.params = {
      // define default params here
      anchor: "top",
      width: "100%",
      offset: 0,
      isStickyAside: false,
      ...params,
    };

    this.disableSticky = false;

    if (this.params.isStickyAside) {
      this.params.offset = this.getAsideOffset();
    }

    this.init();
  }

  init() {
    var self = this;

    this.buildWrapper();
    this.sizeWrapper();

    if (this.params.isStickyAside) {
      this.checkWindowHeight();
    }

    this.waypoint = this.$wrapper.waypoint({
      offset() {
        var r = self.params.offset;

        if (self.params.anchor === "bottom") {
          r =
            $(window).height() -
            self.$domRoot.outerHeight() -
            self.params.offset;
        } else if (self.$wrapper.offset().top === 0) {
          // Sticky navs at very top of page get -1px offset; they will not be 'stuck' until scrolling 1px
          r = -1;
        }

        return r;
      },
      handler(direction) {
        self.scrollPast.call(self, this, direction);
      },
    });
    this.$domRoot.data("instance", this);

    // sticky element content height can change at different widths
    onThrottled($(window), "resize", function () {
      self.sizeWrapper();
      if (self.params.isStickyAside) {
        self.checkWindowHeight();
      }
    });

    // check window height on accordion clicks in side nav
    this.$domRoot.on("click", ".imkt-accordion--heading", function () {
      if (self.params.isStickyAside) {
        self.checkWindowHeight(200);
      }
    });
  }
  
  scrollPast(waypoint, direction) {
    var style = {},
      shouldBeStuck =
        !this.disableSticky &&
        ((this.params.anchor === "top" && direction === "down") ||
          (this.params.anchor === "bottom" && direction === "up"));

    if (shouldBeStuck) {
      if (this.params.anchor === "top") {
        style.top = this.params.offset;
      } else if (this.params.anchor === "bottom") {
        style.bottom = this.params.offset;
      }
    } else {
      style.top = "";
      style.bottom = "";
    }

    style.width =
      typeof this.params.width === "function"
        ? this.params.width()
        : this.params.width;

    this.$domRoot
      .css(style)
      .toggleClass(this.stuckClass, shouldBeStuck)
      .trigger("scrollPast", [shouldBeStuck, direction, waypoint]);

    $("body").toggleClass(this.stuckBodyClass, shouldBeStuck);
  }

  buildWrapper() {
    var wrapperClass = "imkt-sticky-wrapper";
    if (this.$domRoot.hasClass("show-on-stuck")) {
      wrapperClass += " inline";
    }
    if (this.$domRoot.hasClass("left")) {
      wrapperClass += " left";
    }
    if (this.$domRoot.hasClass("right")) {
      wrapperClass += " right";
    }
    if (this.params.isStickyAside) {
      wrapperClass += " imkt-sticky-wrapper--aside";
    }
    if (!this.$wrapper) {
      this.$wrapper = this.$domRoot
        .wrap("<div class='" + wrapperClass + "'>")
        .parent();
    }
  }

  sizeWrapper() {
    if (this.$wrapper) {
      this.$wrapper.css({
        height: this.$domRoot.outerHeight(),
      });
    }
  }

  getAsideOffset() {
    // Check for sticky subnav
    var offset = 0;
    var stickySubnav = $(".imkt-sticky");

    if (stickySubnav.length) {
      offset += stickySubnav.height();
    }
    return offset;
  }

  checkWindowHeight(delay: number) {
    // Make sure we dont make a sticky side nav that's inaccessible
    this.disableSticky = false;

    var windowHeight = $(window).height(),
      footerHeight = $("footer").outerHeight(),
      maxHeight = windowHeight - footerHeight - this.params.offset,
      myHeight = this.$domRoot.outerHeight(),
      self = this;
    delay = delay || 0;

    setTimeout(function () {
      myHeight = self.$domRoot.outerHeight();

      if (myHeight >= maxHeight) {
        self.disableSticky = true;
        self.$domRoot.removeClass(self.stuckClass);
        $("body").removeClass(self.stuckBodyClass);
      }
    }, delay);
  }
}
